// extracted by mini-css-extract-plugin
export default {"box":"TrendingNow_box__hRUnb","icon":"TrendingNow_icon__Sevnz","container":"TrendingNow_container__kz0dU","mrpdis":"TrendingNow_mrpdis__CgIhP","murali":"TrendingNow_murali__ojoRQ"};